import React, { useEffect, useState } from "react";
import style from "./stylesheets/DiscoveryPage.module.scss";
import { Link, useParams } from "react-router-dom";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getUID } from "../helpers/localStorage";
import confetti from "canvas-confetti";
import Button from "./Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import Footer from "./Footer";
import Onboarding from "./Onboarding";

const DiscoveryPage = () => {
    const functions = getFunctions();
    const [error, setError] = useState("");
    const [hintData, setHintData] = useState(null);
    const { token } = useParams();
    const [uid, setUid] = useState(null);

    useEffect(() => {
        // Replace URL to hide token
        window.history.replaceState({}, document.title, "/discover");
        // Then delete the old entry from history
        
        if(uid === null) return;

        (async () => {
            let result;
            try {
                const func = httpsCallable(functions, "discoverHint");
                result = await func({ token, uid });
            } catch(e) {
                if(e.code === "functions/not-found") setError("Cheaters never win.");
                else if(e.code === "functions/failed-precondition") setError("This hint hasn't released yet! Come back later.");
                else setError("Unexpected error");
                return;
            }
            if(!result.data) {
                setError("Failed to fetch hint");
                console.log(result);
                return;
            }
            setHintData(result.data);
            confetti({
                particleCount: 200,
                spread: 200,
                scalar: 1.5,
                ticks: 500,
                disableForReducedMotion: true,
            });
        })();
    }, [functions, token, uid]);

    useEffect(() => {
        setUid(getUID());
    }, []);

    if(!uid) {
        return <Onboarding onClickAction={() => {
            setUid(getUID());
        }} />
    }

    if(!hintData) {
        return (
            <div id={style.discovery_page}>
                <h1>You found me!</h1>
                <h2>Loading your discovery...</h2>
                {error && <p id={style.error}>{error}</p>}
            </div>
        );
    }

    const findMoreButton = (
        <Link to="/">
            <Button text={
                <span>
                    {hintData.isEventStamp ? "See more" : "Find more"}&nbsp;
                    <FontAwesomeIcon icon={faArrowRight} />
                </span>
            } />
        </Link>
    );

    return (
        <div id={style.discovery_page}>
            <h1>{hintData.isEventStamp ? "Stamp collected!" : "You found me!"}</h1>
            <h2>{hintData.title}</h2>
            {
                hintData.isEventStamp ? null : (
                    <p>Please don't take me home! Leave me for others to find.</p>
                )
            }
            {findMoreButton}

            <Footer />
        </div>
    );
};

export default DiscoveryPage;
